import { defineStore } from 'pinia';

export const useCouponStore = defineStore('coupon', {
  state: (): TypeCouponState => ({
    is_coupon_loading: false,
    coupon_data: [],
    temp_coupon_code: '',
  }),
  actions: {
    async checkCupomCode(code: any = false) {
      const { openToaster } = useLayoutStore();
      const { t } = useTexts();

      const session_coupon = localStorage.getItem('temp_coupon_code');

      let code_coupon;

      if (code) {
        code_coupon = code;
      } else if (this.temp_coupon_code) {
        code_coupon = this.temp_coupon_code;
      } else if (session_coupon) {
        code_coupon = session_coupon;
      }

      if (!code_coupon) {
        return;
      }

      this.coupon_data = [];
      this.is_coupon_loading = true;

      const endpoint = `/coupons/${code_coupon}`;

      try {
        const { ApiService } = useApiService();

        await ApiService.get(endpoint)
          .then((res: any) => {
            this.coupon_data = res.data.data;
            this.temp_coupon_code = '';

            if (session_coupon) {
              localStorage.removeItem('temp_coupon_code');
            }

            const { openDepositModal } = usePayments();

            openDepositModal();
          })
          .catch(() => {
            this.temp_coupon_code = '';
            localStorage.removeItem('temp_coupon_code');

            openToaster({
              message: t('deposit.coupon.invalid_coupon'),
              type: 'error',
            });
          })
          .finally(() => {
            this.is_coupon_loading = false;
          });
      } catch (err) {
        this.is_coupon_loading = false;

        openToaster({
          message: t('deposit.coupon.invalid_coupon'),
          type: 'error',
        });
      }
    },
    setTempCoupon(code: any) {
      this.temp_coupon_code = code;
      this.is_coupon_loading = false;
      localStorage.setItem('temp_coupon_code', code);
    },
    removeCoupon() {
      this.temp_coupon_code = '';
      this.is_coupon_loading = false;
      this.coupon_data = [];
      localStorage.removeItem('temp_coupon_code');
    },
    checkAndRemoveCoupon() {
      if (!this.coupon_data || !this.coupon_data.code) {
        return;
      }

      if (!this.coupon_data.end_date) {
        console.warn('⏱️ Expire date not found. Removing...');
        this.removeCoupon();
      }

      const couponEndDate = new Date(this.coupon_data.end_date);
      const currentDate = new Date();

      console.debug('📅 Coupon end date:', couponEndDate);
      console.debug('📅 Current date:', currentDate);

      if (couponEndDate < currentDate) {
        console.warn('⏱️ Coupon expired. Removing...');
        this.removeCoupon();
      }
    },
  },
});
